import {
  SET_ADMIN_STATE
} from './CONSTANTS';
export const setAdmin = bool => {
  return {
    type: SET_ADMIN_STATE,
    value: bool
  };
};



// WEBPACK FOOTER //
// ./src/admin/actions.js